<template>
    <v-card class="border-lg border-primary border-opacity-100 fixed-card">
        <v-card-title>
            <TitleOfDialog title="Missions" @close="emit('close')" />
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
            <v-btn class="mb-3" width="100%" prepend-icon="mdi-plus-thick" color="primary"
                :disabled="!user_perms.find(e => e.name == 'create_mission')" @click="dialogAddMission = true">
                Add mission
            </v-btn>

            <v-data-table :items-per-page-options="[10]" :loading="loading" :items="missions || []"
                :items-length="missions.length" :headers="headers" @update:options="loadItems"
                class="elevation-2 rounded-lg fixed-width-table">
                <template v-slot:body="{ items }">
                    <template v-for="item in items" :key="item.id">

                        <tr @click="goToMission(item)" class="clickable-row">
                            <td class="font-weight-bold">{{ item.name }}</td>
                            <td><v-icon color="info">mdi-map-marker</v-icon>{{ item.location }}</td>
                            <td><v-icon color="success">mdi-calendar</v-icon>{{ getFormatedDate(item.start_date) }}
                            </td>
                            <td class="text-center"><v-icon :color="item.is_public ? 'green' : 'gray'"
                                    :style="{ opacity: item.is_public ? '100%' : '20%' }"
                                    :icon="item.is_public ? 'mdi-earth' : 'mdi-eye-off'"></v-icon>
                            </td>
                            <td class="text-center"><v-icon :color="item.active_mission ? 'red' : 'gray'"
                                    :style="{ opacity: item.active_mission ? '100%' : '20%' }"
                                    :icon="'mdi-circle'"></v-icon>
                            </td>

                            <td class="text-center">
                                <v-btn icon="mdi-eye-arrow-right" :to="`/admin/mission/${item.id}`" color="info"
                                    variant="text" @click="goToMission(item)">
                                </v-btn>
                            </td>
                        </tr>

                    </template>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>

    <v-overlay v-model="dialogAddMission" location="top" style="justify-content:center;align-items: center;">
        <AddMissionForm @close="dialogAddMission = false" />
    </v-overlay>

    <v-overlay v-model="dialogDeleteMission" location="top" style="justify-content:center;align-items: center;">
        <ConfirmForm @close="dialogDeleteMission = false" @confirm="confirmDeleteMission()"
            :text="'Do you want to delete mission ' + missionToDelete.name + '?'" type-to-delete="Mission" />
    </v-overlay>
</template>

<script setup>
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';

import { useMissionStore } from '@/store/missionStore';
import TitleOfDialog from '@/components/base/TitleOfDialog.vue';
import ConfirmForm from '@/components/admin/forms/ConfirmForm.vue';
import AddMissionForm from '@/components/admin/forms/AddMissionForm.vue';
import { useUserStore } from '@/store/userStore';

const emit = defineEmits(['close']);
const props = defineProps({ user_perms: Object });

const dialogAddMission = ref(false);
const dialogDeleteMission = ref(false);

const missionToDelete = ref();
const router = useRouter();


const headers = computed(() => [
    { title: 'Name', align: 'left', sortable: false, key: 'name' },
    { title: 'Location', align: 'left', sortable: false, key: 'location' },
    { title: 'Start date', align: 'left', sortable: false, key: 'date' },
    { title: 'Visibility', align: 'left', sortable: false, key: 'is_public' },
    { title: 'Active mission', align: 'left', sortable: false, key: 'active_mission' },
    { title: 'Actions', align: 'center', sortable: false, key: 'actions' },
]);

const loading = ref(true);
const missionStore = useMissionStore();
const userStore = useUserStore();
const { missions } = storeToRefs(missionStore);

const loadItems = async () => {
    loading.value = true;

    const perms = await userStore.getMissionPerms();
    localStorage.setItem("missionsPerms", JSON.stringify(perms));

    await missionStore.fetchMissions();

    loading.value = false;
};

const goToMission = (mission) => {
    router.push(`/admin/mission/${mission.id}`);
};

// const deleteMission = (mission) => {
//     missionToDelete.value = mission;
//     dialogDeleteMission.value = true;
// };

const confirmDeleteMission = async () => {
    try {
        await missionStore.deleteMission(missionToDelete.value.id);
        dialogDeleteMission.value = false;
    } catch (error) {
        console.error('Error deleting mission:', error);
    }
};

const getFormatedDate = (date) => {
    const newDate = new Date(date);
    return `${newDate.getDate()}/${newDate.getMonth() + 1}/${newDate.getFullYear()}`;
};
</script>

<style scoped>
.clickable-row {
    cursor: pointer;
    transition: background 0.2s ease-in-out;
}

.clickable-row:hover {
    background: rgba(0, 0, 0, 0.05);
}
</style>
